/**
 * @Description 黑底白字的popver
 */

import { Popover, PopoverProps } from 'antd';
import { FC } from 'react';

import styles from './index.module.less';

const V2Popover: FC<PopoverProps> = ({ children, content, ...props }) => {
  return (
    <Popover content={content} overlayClassName={styles['black-white-popover']} {...props}>
      {children}
    </Popover>
  );
};

export default V2Popover;
